// extracted by mini-css-extract-plugin
export default {"card":"cubby_card__wXlld"};